var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIllustrationDiamondinline = function SvgIllustrationDiamondinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m10.596 9.925 1.957-3.913a.5.5 0 0 1 .894 0l1.957 3.913c.145.29.38.526.67.671l3.913 1.957a.5.5 0 0 1 0 .894l-3.912 1.957a1.5 1.5 0 0 0-.671.67l-1.957 3.913a.5.5 0 0 1-.894 0l-1.957-3.912a1.5 1.5 0 0 0-.67-.671l-3.914-1.957a.5.5 0 0 1 0-.894l3.913-1.957a1.5 1.5 0 0 0 .671-.67ZM4.596 33.925l.957-1.912a.5.5 0 0 1 .894 0l.957 1.913c.145.29.38.525.67.67l1.914.957a.5.5 0 0 1 0 .894l-1.913.957a1.5 1.5 0 0 0-.671.67l-.957 1.913a.5.5 0 0 1-.894 0l-.957-1.913a1.5 1.5 0 0 0-.67-.67l-1.914-.957a.5.5 0 0 1 0-.894l1.913-.957a1.5 1.5 0 0 0 .671-.67Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m13.596 53.925.957-1.912a.5.5 0 0 1 .894 0l.957 1.913c.145.29.38.525.67.67l1.913.957a.5.5 0 0 1 0 .894l-1.912.957a1.5 1.5 0 0 0-.671.67l-.957 1.913a.5.5 0 0 1-.894 0l-.957-1.913a1.5 1.5 0 0 0-.67-.67l-1.914-.957a.5.5 0 0 1 0-.894l1.913-.957a1.5 1.5 0 0 0 .671-.67Z",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m82.596 39.925.957-1.912a.5.5 0 0 1 .894 0l.957 1.913c.145.29.38.525.67.67l1.913.957a.5.5 0 0 1 0 .894l-1.912.957a1.5 1.5 0 0 0-.671.67l-.957 1.913a.5.5 0 0 1-.894 0l-.957-1.913a1.5 1.5 0 0 0-.67-.67l-1.913-.957a.5.5 0 0 1 0-.894l1.912-.957a1.5 1.5 0 0 0 .671-.67Z",
    stroke: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m73.596 19.925.957-1.913a.5.5 0 0 1 .894 0l.957 1.913c.145.29.38.526.67.671l1.913.957a.5.5 0 0 1 0 .894l-1.912.957a1.5 1.5 0 0 0-.671.67l-.957 1.913a.5.5 0 0 1-.894 0l-.957-1.912a1.5 1.5 0 0 0-.67-.671l-1.913-.957a.5.5 0 0 1 0-.894l1.912-.957a1.5 1.5 0 0 0 .671-.67Z",
    stroke: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m69.596 61.925 1.957-3.912a.5.5 0 0 1 .894 0l1.957 3.913c.145.29.38.525.67.67l3.913 1.957a.5.5 0 0 1 0 .894l-3.912 1.957a1.5 1.5 0 0 0-.671.67l-1.957 3.913a.5.5 0 0 1-.894 0l-1.957-3.912a1.5 1.5 0 0 0-.67-.671l-3.913-1.957a.5.5 0 0 1 0-.894l3.912-1.957a1.5 1.5 0 0 0 .671-.67Z",
    stroke: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.551 27.5H59.45a.5.5 0 0 1 .423.233l5.327 8.435a.5.5 0 0 1-.031.577L45.392 61.7a.5.5 0 0 1-.784 0L24.832 36.745a.5.5 0 0 1-.03-.577l5.326-8.435a.5.5 0 0 1 .423-.233Z",
    fill: "currentColor",
    fillOpacity: 0.2,
    stroke: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25 36h40v1H25z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m42 27.5-6 9L45 62M48 27.5l6 9L45 62",
    stroke: "currentColor"
  })));
};
export default SvgIllustrationDiamondinline;